import "./Timetable.css";
import React from "react";

export const Timetable = () => {
    return (
        <div className="block" id="Hours">
            <div className="block_content">
                <h1>
                    Godziny otwarcia <i className="fa-solid fa-clock"></i>
                </h1>
                <ul>
                    <li>Poniedziałek: 8:00 - 14:00</li>
                    <li>Wtorek: 12:00 - 18:00</li>
                    <li>Środa: 8:00 - 14:00</li>
                    <li>Czwartek: 12:00 - 18:00</li>
                    <li>Piątek: 8:00 - 14:00</li>
                </ul>
            </div>
        </div>
    );
};
